// extracted by mini-css-extract-plugin
export default {"container":"SignUpPage_container__A1kU5","emailFieldset":"SignUpPage_emailFieldset__giIgz","passwordFieldset":"SignUpPage_passwordFieldset__oCCON"};